import React, { useCallback, useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { FilterTabsState } from 'src/components/Filters/FilterTabs.state';
import { TabButton, TabItem } from 'src/components/Filters/FilterTabs.style';

export interface AvailableItemType {
  id: string;
  name: string;
}

export interface PropsType {
  available: Array<AvailableItemType>;
  active: string | null;
  onChange: (id: string) => void;
  className?: string;
}

interface ItemPropsType {
  active: string | null;
  onChange: (id: string) => void;
  filter: AvailableItemType;
}

const FilterItem = observer('FilterItem', (props: ItemPropsType) => {
    const handleOnClick = useCallback((): void => props.onChange(props.filter.id), [props.filter.id]);
    const isActive = props.active === props.filter.id;

    return (
        <TabItem key={props.filter.id} active={isActive}>
            <TabButton
                onClick={handleOnClick}
                data-test='filter-item-id'
                data-test-filter-item-id={props.filter.id}
                active={isActive}
            >
                {props.filter.name}
            </TabButton>
        </TabItem>
    );
});

export const FilterTabs = observer('FilterTabs', (props: PropsType) => {
    const [state] = useState(() => new FilterTabsState(props));

    const className = props.className === undefined ? 'filters' : props.className;

    return (
        <nav className={className}>
            <ul>
                {props.available.map((filter) => (
                    <FilterItem
                        key={`${filter.id}-filter-item`}
                        active={props.active}
                        onChange={state.selectActive}
                        filter={filter}
                    />
                ))}
            </ul>
        </nav>
    );
});
